<template>
  <v-navigation-drawer
    clipped
    app
    mobile-breakpoint="960"
    v-model="drawer"
    disable-route-watcher
    disable-resize-watcher
  >
    <!-- 모바일 사용자명 로그아웃 -->
    <template v-slot:prepend v-if="$vuetify.breakpoint.smAndDown">
      <v-row style="background-color: var(--v-hcardsearchbg-base)">
        <v-col class="white--text">
          <v-icon dark class="pa-2">mdi-account</v-icon>
          {{ $store.state.user.userName }}
        </v-col>
        <v-btn dark large icon class="mr-4 mt-2" @click="$store.commit('SET_NAVIGATION_DRAWER', false)">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-row>
      <v-divider></v-divider>
      <v-row style="background-color: var(--v-hcardsearchbg-base)">
        <v-col class="text-center pa-2">
          <v-btn class="flex-column justify-center white--text " small link to="/mypage" text>
            마이페이지
          </v-btn>
        </v-col>
        <v-divider vertical ></v-divider>
        <v-col class="text-center pa-2">
          <v-btn small text class="white--text" @click="clickLogout">{{ $t('logout') }}</v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
    </template>
    <vue-scroll :ops="options">
      <v-list nav expand>
        <!--<v-row align="center">
          <v-col cols="12" class="text-right pt-0 pb-0">
            <v-btn icon @click.stop="drawer = !drawer" v-if="$vuetify.breakpoint.mdAndDown">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col class="text-center" cols="12">추가할 영역</v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>-->
        <template v-for="item in menus">
          <!-- 자식이 없는 1st level -->
          <v-list-item v-if="!item.children" color="primary" :key="item.menu_id" :to="item.href">
            <v-list-item-icon v-if="item.icon_path">
              <v-icon>{{item.icon_path}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t(item.menu_id) }}</v-list-item-title>
          </v-list-item>
          <!-- 자식이 있는 1st level group -->
          <v-list-group v-else :group="item.href" color="primary" :key="item.menu_id">
            <!-- 자식이 있는 1st level content -->
            <template v-slot:prependIcon v-if="item.icon_path">
              <v-icon>{{ item.icon_path }}</v-icon>
            </template>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ $t(item.menu_id) }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <!-- 1st level의 자식 반복 -->
            <template v-for="subItem in item.children">
              <!-- 자식이 없는 2nd level -->
              <v-list-item
                v-if="!subItem.children"
                class="pl-10"
                :key="subItem.menu_id"
                :to="subItem.href"
              >
                <v-list-item-icon v-if="subItem.icon_path">
                  <v-icon>{{subItem.icon_path}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ $t(subItem.menu_id) }}</v-list-item-title>
              </v-list-item>
              <!-- 자식이 있는 2nd level group -->
              <v-list-group
                v-else
                color="primary"
                :group="subItem.href==undefined?'':subItem.href.replace(item.href,'')"
                sub-group
                :key="subItem.menu_id"
              >
                <!-- 자식이 있는 2nd level content -->
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t(subItem.menu_id) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <!-- 2nd level의 자식 반복 -->
                <template v-for="subSubItem in subItem.children">
                  <!-- 3rd level-->
                  <v-list-item class="pl-12" :key="subSubItem.menu_id" color="primary" :to="subSubItem.href">
                    <v-list-item-title>{{ $t(subSubItem.menu_id) }}</v-list-item-title>
                    <v-list-item-icon v-if="subSubItem.icon_path">
                      <v-icon>{{ subSubItem.icon_path }}</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </template>
              </v-list-group>
            </template>
          </v-list-group>
        </template>
      </v-list>
    </vue-scroll>
  </v-navigation-drawer>
</template>
<script>
import { getScrollOption } from '@/utils/scroll'
import store from '@/store'
import envs from '@/envs'
import _ from 'lodash'
import Cookies from 'js-cookie'
import router from '@/router'

export default {
  name: 'Navigation',
  data: () => ({
    options: {}
  }),
  created() {
    this.scrollOps()
  },
  computed: {
    drawer: {
      get() {
        return store.state.menu.flag.navigationDrawer
      },
      set(val) {
        store.dispatch('SetNavigationDrawer', val)
      }
    },
    menus() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        // PC일때는 상단 메뉴의 자식 메뉴
        var currentMenu = store.state.menu.selectedMenu.menu_id
        if (!currentMenu) currentMenu = envs.framework.template.home
        var desktopMenus = []
        var targetMenu = _.find(store.state.menu.treeMenus, {
          menu_id: currentMenu
        })
        if (targetMenu && targetMenu.children) desktopMenus = targetMenu.children
        return desktopMenus
      } else {
        return store.state.menu.menus.filter(menu => (menu.menulevel | 0) === 1)
      }
    }
  },
  methods: {
    clickLogout() {
      Cookies.remove('autoLogin')
      router.replace('/logout')
    },
    scrollOps() {
      this.options = getScrollOption()
    }
  }
}
</script>
